module.exports = __webpack_public_path__ + "media/images/emblems/Lavertezzo-coat_of_arms-257d67a01ed8a31e2db858c50e98414a.svg";